import { wccModules } from 'enums/wccModules';
import { TextHelpers } from 'helpers/text';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import IdeationManager from 'managers/ideation';
import { IWCCStorageManager } from 'managers/iStorage';
import doubleLabelPattern from 'patterns/doubleLabel';
import './votesCounter.html';
import './votesCounter.scss';

export interface TaskActivityIdeationVotesCounterVMConfig {
    topicId: SubscribableOrNullableValue<string>
}

@injectable()
export default class TaskActivityIdeationVotesCounterVM {
    availableUpvotes: Subscribable<number>
    message: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) { topicId }: TaskActivityIdeationVotesCounterVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const votesManager = storage.get(IdeationManager, { topicId });
        this.availableUpvotes = votesManager.pluck(m => m.availableUpvotes, 0);

        this.message = ko.pureComputed(() => labels.UpvotesRemaining.replace(doubleLabelPattern, label => TextHelpers.selectLabelFromDoubleLabel(label, this.availableUpvotes())));

        ko.applyBindingsToNode(info.element, {
            'css': {
                'task-activity-ideation-votes-counter': true
            }
        });
    }
}